<template>
  <div class="page-content">
    <el-row style="margin-bottom:10px">
      <el-col :span="6">
        <el-button type="primary" @click="add">添加分组标签</el-button>
      </el-col>
    </el-row>
    <el-row class="dataList">
      <el-table
        ref="multipleTable"
        border
        :data="tableData"
        tooltip-effect="dark"
        :cell-style="acellStyle"
        :header-cell-style="headCellStyle"
        style="width: 100%">
        <el-table-column
         prop="signDesc"
         label="标签名称">
        </el-table-column>
        <el-table-column
         prop="categoryName"
          label="品类名称">
        </el-table-column>
        <el-table-column
         prop="brandName"
          label="品牌名称">
        </el-table-column>
        <el-table-column
         prop="productModel"
          label="型号">
        </el-table-column>
        <el-table-column
         prop="createTime"
          label="创建时间">
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
            <div class="opreationBtn">
              <el-button type="primary" size="mini" @click="handlerClick(scope.row, 'view')"> 查看</el-button>
              <el-button type="primary" size="mini" @click="handlerClick(scope.row, 'edit')"> 编辑</el-button>
              <el-button type="danger" size="mini" @click="handlerClick(scope.row, 'del')"> 删除</el-button>
              <el-button type="success" size="mini" @click="handlerClick(scope.row, 'use')" v-if="scope.row.isEnable === 1"> 启用</el-button>
              <el-button type="warning" size="mini" @click="handlerClick(scope.row, 'stop')" v-if="scope.row.isEnable === 0"> 禁用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <Paging :total="total" @changePage="changePage"/>
    <AddDialog v-if="addDialogVisible" :addDialogVisible="addDialogVisible" @closeAddDialog="closeAddDialog" :rowData="rowData"/>
  </div>
</template>
<script>
import AddDialog from '@/components/groupLabel/addDialog'
import Paging from '@/components/paging'
import { groupList, isUse, isDel } from '@/api/groupLabel'
import { mixin } from '@/mixins/mixin.js'
export default {
  components: {
    Paging,
    AddDialog
  },
  mixins: [mixin],
  data () {
    return {
      addDialogVisible: false,
      // 分页功能
      total: 0, // 到时候从后台获取
      listQuery: {
        page: 1,
        limit: 10
      },
      tableData: [],
      // 设置表格的样式
      acellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      rowData: {}
    }
  },
  created () {
    this.getGroupList()
  },
  methods: {
    getGroupList () {
      const params = {
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit
      }
      groupList({ params }).then(res => {
        const result = res.data.data
        this.tableData = result.data
        this.total = result.total
      })
    },
    add () {
      this.addDialogVisible = true
      this.rowData = {}
    },
    handlerClick (row, val) {
      const params = {
        id: row.signId,
        isDelete: 1
      }
      switch (val) {
        case 'view':
          this.rowData.signId = row.signId
          this.rowData.status = 'view'
          this.addDialogVisible = true
          break
        case 'edit':
          this.rowData.signId = row.signId
          this.rowData.status = 'edit'
          this.addDialogVisible = true
          break
        case 'del':
          params.isDelete = 1
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'error'
          }).then(() => {
            isDel({ params }).then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.cutPage()
                this.getGroupList()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
        case 'use':
          params.isDelete = 0
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '启用成功'
              })
              this.getGroupList()
            }
          })
          break
        case 'stop':
          params.isDelete = 1
          isUse({ params }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '禁用成功'
              })
              this.getGroupList()
            }
          })
          break
      }
    },
    // 分页管理
    changePage (val) {
      this.listQuery = val
      this.getGroupList()
    },
    // 关闭添加弹窗
    closeAddDialog (val) {
      this.addDialogVisible = false
      if (val) {
        //  进行请求
        this.getGroupList()
      }
    }
  }
}
</script>

<style lang='less' scoped>
.dataList{
  .opreationBtn{
    .view{
      color: #df8235;
      cursor: pointer;
    }
    .check,.edit{
      color: #35a6df;
      cursor: pointer;
    }
    .del,.stop{
      color: red;
      cursor: pointer;
    }
    span{
      margin-left: 20px;
    }
  }
}

</style>
